// Booking Slots View
export const SLOT_LIST = '/scheduled';
export const SLOT_DETAILS = '/scheduled/:id';

// Experiences
export const EXPERIENCE_LIST = '/experiences';
export const EXPERIENCE_EDIT = '/experiences/:id/edit';

// Profile
export const PROFILE = '/profile';
